import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { hydrateStore } from './lib/store'
import { installDomSafetyGuards } from './lib/domSafety'

// Survive browser translation tools that mutate React's DOM (prevents the
// "removeChild: not a child" crash). Must run before the first render.
installDomSafetyGuards()

// Pull live content from Supabase into the in-memory store at startup.
hydrateStore()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
